module.exports = __webpack_public_path__ + "static/img/footerPisc.07a352fd.jpg";